import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { AuditLogViewer } from "@/features/admin/components/audit-log-viewer";
import { PageContainer } from "@fleet/ui";

interface AdminAuditLogSearch {
  entityType?: string;
  action?: string;
  userId?: string;
  page?: number;
}

function AdminAuditPage() {
  return (
    <PageContainer maxWidth="6xl">
      <AuditLogViewer />
    </PageContainer>
  );
}

export const adminAuditRoute = createRoute({
  getParentRoute: () => adminRoute,
  // The security audit log lives at the canonical `/admin/audit` (the old
  // font-integrity "audit" page was removed; it was a mock that no longer
  // applies under the CDN-only font system).
  path: "/audit",
  validateSearch: (search: Record<string, unknown>): AdminAuditLogSearch => {
    const out: AdminAuditLogSearch = {};
    if (typeof search.entityType === "string" && search.entityType.trim() !== "") {
      out.entityType = search.entityType;
    }
    if (typeof search.action === "string" && search.action.trim() !== "") {
      out.action = search.action;
    }
    if (typeof search.userId === "string" && search.userId.trim() !== "") {
      out.userId = search.userId;
    }
    const page = Number(search.page);
    if (Number.isFinite(page) && page > 1) {
      out.page = Math.floor(page);
    }
    return out;
  },
  component: AdminAuditPage,
});
